import React from 'react';
import { ContentLoader } from '@dev/ee-components';
import styled from 'styled-components';

const ContentLoaderWrapper = styled.div`
    margin-right: 16px;
    min-width: 45px;
    flex: 1;
`;
const LoaderConteiner = styled.div`
    margin-top: 20px;
`;

export const Loader = (): JSX.Element => (
    <LoaderConteiner>
        <ContentLoaderWrapper>
            <ContentLoader mode="row" height={22} />
        </ContentLoaderWrapper>
        <ContentLoaderWrapper>
            <ContentLoader mode="row" height={22} />
        </ContentLoaderWrapper>
        <ContentLoaderWrapper>
            <ContentLoader mode="row" height={22} />
        </ContentLoaderWrapper>
    </LoaderConteiner>
);
